import { useEffect, FC } from 'react';
import { useMap } from 'react-leaflet';
import { LatLngExpression } from 'leaflet';

interface MapControllerProps {
  center: LatLngExpression;
}

const MapController: FC<MapControllerProps> = ({ center }) => {
  const map = useMap();
  
  useEffect(() => {
    if (center) {
      map.setView(center, map.getZoom());
    }
  }, [center, map]);
  
  return null;
};

export default MapController;